// extracted by mini-css-extract-plugin
module.exports = {"bibliography":"bibliography_bibliography__fWSZP"};